function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { faTrashAlt, faClone } from "@fortawesome/pro-regular-svg-icons";
import { faCloudUploadAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export var CloneIcon = function CloneIcon(props) {
  return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({}, props, {
    icon: faClone
  }));
};
export var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({}, props, {
    icon: faTrashAlt
  }));
};
export var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({}, props, {
    icon: faCloudUploadAlt
  }));
};